import { createContext, useContext, type ReactNode } from 'react';

export interface MarketCardsConfig {
  /** When true, all cards in the panel render in compact view regardless of their per-card config. */
  forceCompact: boolean;
}

const DEFAULT_CONFIG: MarketCardsConfig = { forceCompact: false };

const MarketCardsConfigContext = createContext<MarketCardsConfig>(DEFAULT_CONFIG);

export function MarketCardsConfigProvider({ value, children }: { value: MarketCardsConfig; children: ReactNode }) {
  return <MarketCardsConfigContext.Provider value={value}>{children}</MarketCardsConfigContext.Provider>;
}

export function useMarketCardsConfig(): MarketCardsConfig {
  return useContext(MarketCardsConfigContext);
}
